import React, { useState } from "react";
import "./styles.scss";
import PropTypes from "prop-types";

const ContainerMessagerie = ({ children }) => {
	const [bottom, setBottom] = useState(true);
	const [top, setTop] = useState(true);

	const handleScroll = (e) => {
		const bottomScroll = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

		if (bottomScroll) {
			setBottom(true);
		} else {
			setBottom(false);
		}

		const topScroll =  e.target.scrollTop;
		if (topScroll < 10) {
			setTop(true);
		} else {
			setTop(false);
		}
	};
	return (
		<div className="container-messages">
			<div onScroll={handleScroll} id="containerMessages">
				{children}
			</div>

			<div className={`${top ? "" : "top-gradient" }`} ></div>


			<div className={`${bottom ? "" : "bottom-gradient" }`} ></div>
			
		</div>
	);
};

ContainerMessagerie.propTypes = {
	children: PropTypes.node,
};

export default ContainerMessagerie;